import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../query-keys';

export function useMarketComponentHistorySelectByMarketId(
  marketId: string | undefined,
  page: number,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: queryKeys.marketComponentHistory.byMarketId(marketId, page),
    enabled: enabled && !!marketId,
    queryFn: async () => {
      const res =
        await api.marketComponentHistoryApi.apiMarketComponentHistoriemarketMarketIdGetCollection(
          marketId!,
          page
        );

      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
